import { FormControl, Grid, InputLabel, Select, TextField, Typography, Box } from '@mui/material';
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListTemas, setListEstados } from "../redux/objetivoCatalogoSlice";
import { FormHelperText as HelperText } from '@mui/material';

// Mantenimiento del catalogo de objetivos: los objetivos que se pueden
// asignar a los participantes, agrupados por tema de evaluacion.
const ObjetivoCatalogo = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.objetivoCatalogo.entity);
    const defaultEntity = useSelector((state) => state.objetivoCatalogo.defaultEntity);
    const listTemas = useSelector((state) => state.objetivoCatalogo.listTemas);
    const listEstados = useSelector((state) => state.objetivoCatalogo.listEstados);
    const validate = useSelector((state) => state.objetivoCatalogo.validationActive);
    const dispatch = useDispatch();

    var validation = {
        idTemaEvaluacion: {
            error: entity.idTemaEvaluacion == null || entity.idTemaEvaluacion == 0,
            message: "Falta ingresar el tema",
        },
        nombre: {
            error: entity.nombre == null || entity.nombre.trim().length < 1,
            message: "Falta ingresar el nombre",
        },
        idEstado: {
            error: entity.idEstado == null || entity.idEstado == 0,
            message: "Falta ingresar el estado",
        },
    }

    const fetchEntity = useCallback(async () => {
        if (parseInt(params.id || "0") <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        await api.get("/Evaluacion/GetsObjetivoCatalogoView")
            .then((response) => {
                const encontrado = (response.data?.data || []).find((row) => row.id == params.id);

                if (encontrado == null) {
                    dispatch(setEntity(defaultEntity));
                }
                else {
                    dispatch(setEntity(encontrado));
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }, [])

    // Los grupos (tema padre) no se listan: solo los temas que se evaluan.
    const fetchListTemas = useCallback(async () => {
        const response = await api.get("/Evaluacion/GetsTemaEvaluacionView")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListTemas((response?.data?.data || []).filter((row) => row.idTemaPadre != null)));
    }, [])

    const fetchListEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstados(response?.data?.data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListTemas();
        fetchListEstados();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        });

        return messages;
    }

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idTemaEvaluacion && validation.idTemaEvaluacion.error}>
                        <InputLabel htmlFor="input-tema">Tema</InputLabel>
                        <Select
                            native
                            label="Tema"
                            value={entity.idTemaEvaluacion}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTemaEvaluacion',
                                id: 'input-tema',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTemas.map((row) => (
                                <option key={row.id} value={row.id}>{row.temaPadre + " - " + row.nombre}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idTemaEvaluacion && validation.idTemaEvaluacion.error ? validation.idTemaEvaluacion.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl required fullWidth error={validate.nombre && validation.nombre.error}>
                        <TextField
                            required
                            name="nombre"
                            label="Nombre"
                            fullWidth
                            value={entity.nombre}
                            onChange={setDataEntity}
                            error={validate.nombre && validation.nombre.error}
                            helperText={validate.nombre && validation.nombre.error ? validation.nombre.message : ""}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <TextField
                            name="descripcion"
                            label="Descripcion"
                            fullWidth
                            value={entity.descripcion}
                            onChange={setDataEntity}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idEstado && validation.idEstado.error}>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.idEstado}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idEstado',
                                id: 'input-estado',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstados.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idEstado && validation.idEstado.error ? validation.idEstado.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ObjetivoCatalogo;
